export default __webpack_public_path__ + "static/poster-eda9ee6eb2ca7c2e90339141171ec805.png";